<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24.429" height="24.429" viewBox="0 0 24.429 24.429">
    <g id="Gruppe_110" data-name="Gruppe 110" transform="translate(-301.362 -123.568)">
      <circle id="Ellipse_20" data-name="Ellipse 20" cx="9.5" cy="9.5" r="9.5" transform="translate(302.112 124.318)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_77" data-name="Pfad 77" d="M308.845,137.233a6.183,6.183,0,0,1,6.183-6.183" transform="translate(-3.237 -3.237)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_78" data-name="Pfad 78" d="M333.728,158.532l5.846,5.845a2.6,2.6,0,0,0,2.6-2.6l-5.845-5.845" transform="translate(-17.13 -17.131)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="1.5"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "magnifyGlass"
}
</script>

<style scoped>

</style>